import { CardSubtitle } from '@7f-ui/components/card/card'

import { useExperienceDuration } from '../hooks/use-experience-data'

type ExperienceSubtitleProps = {
  duration?: number | null
  hasMultipleDurations?: boolean
  locationName?: string | null
}

export function ExperienceSubtitle({
  duration,
  hasMultipleDurations,
  locationName,
}: ExperienceSubtitleProps) {
  const durationFormatted = useExperienceDuration(duration, hasMultipleDurations)

  if (!duration) {
    return <CardSubtitle subtitle={locationName} />
  }

  return <CardSubtitle subtitle={`${locationName ?? ''} · ${durationFormatted}`} />
}
